import { Box, Flex } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import RecoverPasswordArea, { RecoverPasswordQueryParams } from 'components/RecoverPassword/RecoverPassword';
import image from 'resources/shutterstock_691534279.jpg';
import { readQuery } from 'utils/helpers';
import LoggedInMessage from 'components/common/LoggedInMessage/LoggedInMessage';
import { useUser as useCurrentUser } from 'contexts';
import { ThemeContext } from 'contexts/themeContext';
import { Link } from 'components/UI';
import { PageTitle } from 'components/common/PageTitle';
import AppRoutes from 'constants/routes';
import { base2ColourGradient } from 'constants/theme';

const RecoverPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentUser] = useCurrentUser();

  const queryParams = location ? readQuery(location) : undefined;

  const handleRecover = () => {
    navigate(AppRoutes.Landing);
  };

  const renderRecoverPassword = currentUser ? (
    <LoggedInMessage />
  ) : (
    <RecoverPasswordArea
      queryParams={queryParams as RecoverPasswordQueryParams | undefined}
      onRecover={handleRecover}
    />
  );

  const renderLoginLink = !currentUser ? (
    <Link color="primaryThemeColour.400" to="/">
      Back to login
    </Link>
  ) : null;

  return (
    <ThemeContext.Consumer>
      {() => (
        <Box
          sx={{
            bgColor: 'white',
            bgImage: `url(${image})`,
            w: '100%',
            bgSize: '2000px 1000px',
          }}
          data-testid="recover-password-page"
        >
          <Flex
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
              w: '100%',
              bg: base2ColourGradient,
              height: '100vh',
            }}
          >
            <Box textAlign="center" backgroundColor="white" py={8} px={6} w={600} borderRadius={6}>
              <PageTitle>Password Recovery</PageTitle>
              <Box py={6}>{renderRecoverPassword}</Box>
              {renderLoginLink}
            </Box>
          </Flex>
        </Box>
      )}
    </ThemeContext.Consumer>
  );
};

export default RecoverPassword;
